import { useContext } from 'react'
import { GeometryContext } from '../store/store'
import {RigidBody} from '@react-three/rapier'
import { useRef, useState } from 'react'
import { useFrame } from '@react-three/fiber'
import {useSelector} from 'react-redux'


const BlockLimbo = ({position = [0,0,0]}) => {
    const geometryCtx = useContext(GeometryContext)
    // const geometryState = useSelector((state)=>state.geometry)
    const obstacle = useRef()
    const [timeOffset] = useState(()=> Math.random() * Math.PI * 2)

    useFrame((state)=>{
        const time = state.clock.getElapsedTime()
        const y = Math.sin(time + timeOffset) + 1.15
        obstacle.current.setNextKinematicTranslation({x: position[0], y: y, z: position[2]})
    })

    return (
        <group position={position}>
            <mesh 
                geometry={geometryCtx.boxGeometry} 
                material={geometryCtx.floor2Material}
                scale={[4,0.2,4]}
                position={[0,-0.1,0]}
                receiveShadow
            />
            <RigidBody ref={obstacle} type='kinematicPosition' position={[0,0.2,0]} restitution={0.2} friction={0}>
                <mesh
                    geometry={geometryCtx.boxGeometry}
                    material={geometryCtx.obstacleMaterial}
                    scale={[3.5,0.3,0.3]}
                    castShadow
                />
            </RigidBody>
        </group>
    )
}

export default BlockLimbo